import Loader from 'react-loader-spinner'
import './styles.sass'

export const LoaderWindow = () => {
    return(
        <div className="loader-window-wrapper">
            <Loader type='Rings' color="#4169E1"/>
        </div>
    )
}